import React from 'react'
import Js from '../../images/js.png'
import Python from '../../images/python.png'
import react from '../../images/react.png'
import nodejs from '../../images/nodejs.png'
import html5 from '../../images/html5.png'
import css from '../../images/css.png'
import mongo from '../../images/mongodb.png'
import fire from '../../images/firebase.png'
import sass from '../../images/sass.png'
import git from '../../images/git.png'
import redux from '../../images/redux.png'
import { useSpring, animated } from 'react-spring'
import './Skills.css'

const calc = (x, y) => [
  -(y - window.innerHeight / 2) / 20,
  (x - window.innerWidth / 2) / 20,
  1.1,
]
const trans = (x, y, s) =>
  `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

const Skills = () => {
  const [props, set] = useSpring(() => ({
    xys: [0, 0, 1],
    config: { mass: 5, tension: 350, friction: 40 },
  }))

  const skills = [
    {
      title: 'JavaScript',
      img: Js,
    },
    {
      title: '  Python',
      img: Python,
    },
    {
      title: 'React',
      img: react,
    },
    {
      title: 'Redux',
      img: redux,
    },
    {
      title: 'Node JS (Express)',
      img: nodejs,
    },
    {
      title: 'HTML 5',
      img: html5,
    },
    {
      title: 'CSS',
      img: css,
    },
    {
      title: 'MongoDB',
      img: mongo,
    },
    {
      title: 'Firebase',
      img: fire,
    },
    {
      title: 'Sass',
      img: sass,
    },
    {
      title: 'Github',
      img: git,
    },
  ]

  return (
    <div id="skills" data-aos="fade-right" data-aos-easing="ease-in-out-cubic">
      <h2 style={{ textAlign: 'center', padding: '10px', color: '#006ADC' }}>
        SKILLS
      </h2>
      <div className="skillsMain">
        <animated.div
          className="row d-flex justify-content-center flex flex-wrap content-center"
          onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
          onMouseLeave={() => set({ xys: [0, 0, 1] })}
          style={{ transform: props.xys.interpolate(trans) }}
        >
          {skills.map((skill) => (
            <div key={skill.title} className="col-sm-6 col-md-1 skills">
              <p style={{ color: ' #ffff' }}>{skill.title}</p>
              <img
                className="fluid skillImg w-16 md:w-32 lg:w-48"
                src={skill.img}
                alt={skill.title}
              />
            </div>
          ))}
        </animated.div>
      </div>
    </div>
  )
}

export default Skills
